import React from 'react';
import styled from 'styled-components';
import PyramidGrid from '../../Common/PyramidGrid/PyramidGrid';
import { mockedLogos } from '../../Theming/images';
import { tabletMediaQuery } from '../../Theming';
import { isMobile } from '../../Common/Utils/platforms';
import { Trans } from 'react-i18next';
import clsx from 'clsx';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TextContainer = styled.div`
  padding-inline: 24px;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  ${tabletMediaQuery} {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const HeaderText = styled.span`
  font-weight: bold;
  font-family: Arial;
  font-size: 30px;

  ${tabletMediaQuery} {
    font-size: 16px;
  }
`;

const MainText = styled.span`
  font-weight: 400;
  font-family: Arial;
  font-size: 20px;
  margin-top: 7px;

  ${tabletMediaQuery} {
    font-size: 14px;
  }

  &.text-centered {
    text-align: center;
  }
`;

const CashSaverBrandsContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  font-family: Arial;
  padding-top: 24px;

  &.noPaddingTop {
    padding-top: 0px;
  }
`;

const LogoImage = styled.img`
  height: 30px;
`;

interface CashSaverBrandProps {
  headerText?: string;
  mainText?: string;
  mainTextClassName?: string;
  headerTextClassName?: string;
  noPaddingTop?: boolean;
}

const CashSaverBrands: React.FC<CashSaverBrandProps> = ({
  headerText,
  mainText,
  mainTextClassName,
  headerTextClassName,
  noPaddingTop,
}) => {
  const sampleImages = Object.values(mockedLogos);
  const items = Array.from({ length: 27 }).map((_, i) => ({
    image: sampleImages[(i + 1) % sampleImages.length],
  }));

  return (
    <Container>
      <TextContainer>
        <Trans>
          <HeaderText className={headerTextClassName}>{headerText}</HeaderText>
          <MainText className={mainTextClassName}>{mainText}</MainText>
        </Trans>
      </TextContainer>

      <CashSaverBrandsContainer className={clsx({ noPaddingTop })}>
        <PyramidGrid
          renderItem={(item) => <LogoImage src={item?.image?.default} />}
          items={items}
          numRows={isMobile() ? 3 : 2}
          maxItemsAtBase={9}
        />
      </CashSaverBrandsContainer>
    </Container>
  );
};

export default CashSaverBrands;
